

/**
 * @name SignupShopController
 * @description Controller for the sign up shop process
 * @param {unknown} Session The session service
 * @param {unknown} ENDPOINT The Endpoint constant
 * @param {unknown} CheckUsername The check username service
 * @param {unknown} Collector The collector service
 * @param {unknown} _ Lodash
 * @param {unknown} $log Angular $log service
 * @param {unknown} $state UI Router $state service
 * @param {unknown} DEFAULT_STATES The default states constant
 */
function SignupCollectorController(
  Session,
  ENDPOINT,
  CheckUsername,
  Collector,
  _,
  $log,
  $state,
  DEFAULT_STATES
) {
  let vm = this;

  vm.$onInit = function() {
    $log.debug('As: ', vm.as);
    vm.collectorTmp = _.cloneDeep(Session.collector);
    vm.collectorTmp.is_new_user = false;
    vm.checkUsername = checkUsername;
    vm.updateCollector = updateCollector;
    vm.collectorTmp.profile_photo = null;
    vm.steps = [
      {
        id: 1,
        name: 'create-collector',
        title: 'Create your collector profile'
      },
      {
        id: 2,
        name: 'update-collector',
        title: 'Complete your personal profile'
      },
      {
        id: 3,
        name: 'create-shop',
        title: 'Create your shop profile'
      }
    ];
    vm.activeStep = _.find(vm.steps, {name: 'update-collector'});
  };

  /**
   * @name checkUsername
   * @description Function to check it a username exists when setting one
   * @param {string} username The username to check
   */
  function checkUsername(username) {
    CheckUsername.check(username)
    .then(function(results) {
      vm.usernameResults = results;
    });
  }

  /**
   * @name updateCollector
   * @description Function to update the collector
   * @param {object} collector The data from the form.
   */
  function updateCollector(collector) {
    Collector.updateProfile(collector).then(function(updatedCollector) {
      let next = '';
      if (vm.as === 'collector') {
        next = DEFAULT_STATES.buying;
      } else {
        next = 'signup.' + vm.as;
      }
      $state.go(next);
    });
  }
}

angular
  .module('inkfinder')
  .controller('SignupCollectorController', SignupCollectorController);



// WEBPACK FOOTER //
// ./components/signup/collector/signup-collector.controller.js